import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthStatusService } from '../../services/auth-status.service';
import { ExpertService } from 'src/app/services/expert.service';
import { Operation } from 'src/app/models/operation.schema';
import { OperationService } from 'src/app/services/operation.service';

@Injectable()
export class ViewRestricted implements CanActivate {

    groups: any;
    teamLeader: any;
    isTeamLeader: boolean = false;
    opeartion: Operation;
    isProjectManager: boolean = false;

    constructor(
        private authService: AuthStatusService, 
        private router: Router, 
        public jwtHelper: JwtHelperService,
        private expertService: ExpertService,
        private operationService: OperationService,
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isAuthenticated: boolean = await this.authService.isAuthenticated();

        if (isAuthenticated) {
            const loggedInUserInfo = await this.authService.getTokenInfo();
            
            /*
            if(loggedInUserInfo.roles.includes('expert')) {
                const loggedInExpert = await this.expertService.getOne(loggedInUserInfo['extraId']);
                this.isTeamLeader = loggedInExpert?.isTeamLeader;
                if(!this.isTeamLeader){
                    this.router.navigate(['/activities/own']);    
                    return false;
                }
            }
            */

            if(loggedInUserInfo.roles.includes('operation')) {
                const loggedInUser: Operation = await this.operationService.getOne(loggedInUserInfo['extraId']);
                this.isProjectManager = loggedInUser?.isProjectManager;
                if (this.isProjectManager) {
                    this.router.navigate(['/prodotti/attiva']);
                    return false;
                }
            }
           
            return true;
        }
    }
}
